/* @sravni/react-design-system version 0.2.65 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, useId, safeInvoke, noop } from '@sravni/react-utils';
import Star from './Star.js';
import { STAR_SIZES } from '../../../constants/sizes.js';
import modules_d76667db from '../styles/Rate.module.less.js';

var fractionalIndex = function (event) {
    var x = event.clientX - event.currentTarget.getBoundingClientRect().left;
    var offset = x / event.currentTarget.offsetWidth;
    if (offset <= 0.3) {
        return 0.3;
    }
    if (offset > 0.3 && offset <= 0.5) {
        return 0.5;
    }
    if (offset > 0.5 && offset <= 0.8) {
        return 0.8;
    }
    return 1;
};
/**
 * @description A quick rating operation on something
 *
 * @component
 * @example
 * ```jsx
 * <Rate allowHalf defaultValue={4} count={5} size={36}>
 * ```
 */
var Rate = React.forwardRef(function (props, ref) {
    var _a;
    var allowHalf = props.allowHalf, count = props.count, defaultValue = props.defaultValue, value = props.value, size = props.size, disabled = props.disabled, onChange = props.onChange, className = props.className, restProps = __rest(props, ["allowHalf", "count", "defaultValue", "value", "size", "disabled", "onChange", "className"]);
    var cx = useStyles(modules_d76667db);
    var id = useId('rate');
    var classNames = cx(className, 'container', (_a = {},
        _a["size-" + size] = size,
        _a['disabled'] = disabled,
        _a));
    var _b = __read(React.useState(defaultValue || value || 0), 2), innerValue = _b[0], setInnerValue = _b[1];
    var _c = __read(React.useState(null), 2), hoverIndex = _c[0], setHoverIndex = _c[1];
    var handleHover = React.useCallback(function (event, index) {
        var value = allowHalf ? index + fractionalIndex(event) : index + 1;
        setHoverIndex(value);
    }, [allowHalf]);
    var handleMouseLeave = React.useCallback(function () {
        setHoverIndex(null);
    }, []);
    var handleClickRate = React.useCallback(function (event, index) {
        var value = allowHalf ? index + fractionalIndex(event) : index + 1;
        setInnerValue(value);
        safeInvoke(onChange, value);
    }, [allowHalf, onChange]);
    var stars = React.useMemo(function () {
        return Array.from(new Array(count)).map(function (_, index) { return (React.createElement(Star, { key: id + "-" + index, index: index, value: hoverIndex === null ? innerValue : hoverIndex, allowHalf: allowHalf, disabled: disabled, size: size, onHover: handleHover, onClick: handleClickRate })); });
    }, [id, hoverIndex, innerValue, count, disabled, allowHalf, size, handleClickRate, handleHover]);
    React.useEffect(function () {
        value && setInnerValue(value);
    }, [value]);
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "Rate", className: classNames }, restProps, { onMouseLeave: disabled ? noop : handleMouseLeave }), stars));
});
Rate.defaultProps = {
    allowHalf: false,
    count: 5,
    size: STAR_SIZES.S20,
};
Rate.displayName = 'Rate';

export default Rate;
//# sourceMappingURL=Rate.js.map
